import { __rest } from "tslib";
import React, { createContext, useContext } from 'react';
export const VideoConfigContext = createContext({});
export const VideoConfigProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(VideoConfigContext.Provider, { value: props }, children));
};
export const useVideoConfig = () => useContext(VideoConfigContext);
//# sourceMappingURL=video-config-provider.js.map